import { render, staticRenderFns } from "./ReCardTicketFaq.vue?vue&type=template&id=563ad615&scoped=true"
import script from "./ReCardTicketFaq.vue?vue&type=script&lang=js"
export * from "./ReCardTicketFaq.vue?vue&type=script&lang=js"
import style0 from "./ReCardTicketFaq.vue?vue&type=style&index=0&id=563ad615&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563ad615",
  null
  
)

export default component.exports